module.exports = __webpack_public_path__ + "static/img/20240809_1.636387f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240809_1.png
// module id = WisR
// module chunks = 0